import { call, put } from "redux-saga/effects"
import { push } from 'connected-react-router'
import { Modal } from 'antd'
import axios from 'axios'
import config from '../config'

import { 
    fetchOwnerSuccess,fetchOwnerFailed,
    createOwnerSuccess,createOwnerFailed,
    deleteOwnerSuccess,deleteOwnerFailed,
    updateOwnerSuccess,updateOwnerFailed,
} from "../actions/owner"


import { resetAuth } from "../actions/auth"

export function* fetchOwner(action) {
    const id = action.payload
    const url = config.API_URL+`/admin/owners/${id}`
    try {
        const response = yield axios({
            method: 'get',
            url: url,
        })
        if(response.data.successful){
            yield put(fetchOwnerSuccess(response.data.owner))
        }
    }catch(error){
        let message = error.message
        if(error.response){
            message = error.response.data.message
            if(error.response.status == 401){
                yield put(resetAuth())
            }
        }
        yield put(fetchOwnerFailed(message))
    }
}
export function* createOwner(action) {
    const owner = { ...action.payload }
    const url = config.API_URL+`/admin/owners`
    try {
        const { 
            title,
            name,
            phone,
            surname,
            education_id,
            email,
            image
        } = owner

        const formData = new FormData()
        formData.append("title",title)
        formData.append("name",name)
        formData.append("surname",surname)
        formData.append("phone",phone)
        formData.append("education_id",education_id)
        formData.append("email",email)
        if(image !== undefined){
            formData.append("image",image)
        }
        const response = yield axios({
            method: 'post',
            url: url,
            data: formData,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        })
        if(response.data.successful){
            yield put(createOwnerSuccess(response.data.message))
            yield put(push(`/owners`))
        }
    }catch(error){
        let message = error.message
        if(error.response){
            message = error.response.data.message
            if(error.response.status == 401){
                yield put(resetAuth())
            }
        }
        yield put(createOwnerFailed(message))
    }
}

export function* deleteOwner(action) {
    const id = { ...action.payload }
    const url = config.API_URL+`/admin/owners/{id}/delete`
    try {
        const response = yield axios({
            method: 'post',
            url: url,
        })
        if(response.data.successful){
            yield put(deleteOwnerSuccess(response.data.message))
            yield put(push(`/owners`))
        }
    }catch(error){
        let message = error.message
        if(error.response){
            message = error.response.data.message
            if(error.response.status == 401){
                yield put(resetAuth())
            }
        }
        yield put(deleteOwnerFailed(message))
    }
}

export function* updateOwner(action) {
    const owner = action.payload
    const owner_id = owner.id
    const url = config.API_URL+`/owners/${owner_id}`
    try {
        const { 
            title,
            name,
            surname,
            phone,
            education_id,
            email,
            image
        } = owner

        const formData = new FormData()
        formData.append("title",title)
        formData.append("name",name)
        formData.append("surname",surname)
        formData.append("phone",phone)
        formData.append("education_id",education_id)
        formData.append("email",email)
        if(image !== undefined){
            formData.append("image",image)
        }
        const response = yield axios({
            method: 'post',
            url: url,
            data: formData,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        })
        if(response.data.successful){
            yield put(updateOwnerSuccess(response.data.message))
            yield put(push(`/owners`))
        }
    }catch(error){
        let message = error.message
        if(error.response){
            message = error.response.data.message
            if(error.response.status === 401){
                yield put(resetAuth())
            }
        }
        yield put(updateOwnerFailed(message))
    }
}
